import styled from "styled-components";

export const CoinPage = styled.div`
  width: 100%;

  > * {
    width: 100%;
  }
`;
